import { render, staticRenderFns } from "./EmojiSlider.vue?vue&type=template&id=e84f2af4&"
import script from "./EmojiSlider.vue?vue&type=script&lang=js&"
export * from "./EmojiSlider.vue?vue&type=script&lang=js&"
import style0 from "./EmojiSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports